/**
 * @ngdoc components
 * @name factory:showDeleted
 *
 * @description
 *
 */
angular
    .module('festzelt-os.components')
    .factory('showDeleted', [
        showDeleted
    ]);

function showDeleted() {
    return {
        key: 'show-deleted',
        title: 'Show archived',
        level: 'settings',
        manager: 'showArchived'
    }
}



// WEBPACK FOOTER //
// ./src/app/components/workflows/general/show-deleted.js